import { render, staticRenderFns } from "./CurrentVisitors.vue?vue&type=template&id=1fae7a11&"
import script from "./CurrentVisitors.vue?vue&type=script&lang=js&"
export * from "./CurrentVisitors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports